import {Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {NoticeEntry} from "../../pages/client/alarms/notices/notice.entry";

@Pipe({name: 'tunnelReservationNotice'})
export class TunnelReservationNoticePipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  public transform(value: NoticeEntry): string {
    if (value != null) {
      let additionalInfos = value.additionalInfo.split(' / ');
      let tunnelName = additionalInfos[0] != null
        ? this.translate.instant('messages.notices.tunnelName.' + additionalInfos[0])
        : '';
      let arrivingAt = additionalInfos[1]
      let reservationNumber = '';
      if (additionalInfos[2] === 'NOT_AVAILABLE') {
        reservationNumber = ', ' + this.translate.instant('messages.notices.tunnelReservationNumber') + ' '
          + this.translate.instant('messages.notices.tunnelReservationNumberNotAvailable');
      } else if (additionalInfos[2] != null) {
        reservationNumber = ', ' + this.translate.instant('messages.notices.tunnelReservationNumber') + ' ' + additionalInfos[2];
      }
      return `${tunnelName}` + ' ' + `${arrivingAt}` + `${reservationNumber}`;
    }
    return '';
  }
}
